import { IonButton, IonIcon, IonItem, IonLabel } from "@ionic/react";
import { business, fileTrayOutline, person, trashOutline } from "ionicons/icons";
import React from "react";

import { Template } from "../../../@types/template";
import { useHistory } from "react-router-dom";

interface Props {
  template: Template;
}

export const FileTemplateListItem: React.FC<Props> = ({ template }) => {
  const history = useHistory();
  return (
    <IonItem
      button
      onClick={() => history.push(`/app/tic/plantillas-file/detalle/${template.id}`, { state: { template } })}
      class="ion-margin-bottom"
      lines="none"
      detail
    >
      <IonLabel>
        <h2 style={{ fontWeight: 500 }}>{template.name}</h2>
      </IonLabel>
      <IonIcon icon={template.assignedTo === "user" ? person : business} />
    </IonItem>
  );
};
